"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// form 组件混入
var _default2 = exports.default = {
  props: {
    propsData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  watch: {
    form: {
      handler: function handler(val) {
        this.$emit('updateForm', val);
      },
      deep: true
    },
    propsData: {
      handler: function handler(val) {
        this.form = val;
      }
    }
  }
};